<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="item">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`編號`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.docId"
              :disabled="!isNew"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="departmentList"
                      v-model="editedItem.department"
                      label="部門"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="categoryList"
                      v-model="editedItem.category"
                      label="類型"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.category.indexOf('收入') > -1">
          <v-flex xs12>
            <v-select :items="inAccountTypeList"
                      v-model="editedItem.accountType"
                      label="會計科目"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-else>
          <v-flex xs12>
            <v-select :items="outAccountTypeList"
                      v-model="editedItem.accountType"
                      label="會計科目"
            ></v-select>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <v-flex>
            <v-textarea
              :label="`收支用途`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.reason"
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-textarea
              :label="`無法取得單據事由(恕不接受忘記了)`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.noDocReason"
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="invoiceTypeList"
                      v-model="editedItem.invoiceType"
                      label="票據類型"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`單據號碼`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.invoiceNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`二聯發票號碼`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.invoiceNumberV2"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`三聯發票號碼`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.invoiceNumberV3"
            ></v-text-field>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`${ editedItem.category === '收入'? '廠商':'客戶' }名稱`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.vendor"
            ></v-text-field>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`${ editedItem.category === '收入'? '廠商':'客戶' }電話`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.vendorPhone"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`${ editedItem.category === '收入'? '廠商':'客戶' }地址`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.vendorAddress"
            ></v-text-field>
          </v-flex>
        </v-layout>



        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="tradeTypeList"
                      v-model="editedItem.tradeType"
                      label="交易方式"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.tradeType === '匯款' || editedItem.tradeType === '支票'">
          <v-flex>
            <v-text-field
              :label="`${editedItem.tradeType}銀行`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.bankName"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.tradeType === '匯款'">
          <v-flex>
            <v-text-field
              :label="`匯款帳號`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.bankNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.tradeType === '支票'">
          <v-flex>
            <v-text-field
              :label="`支票號碼`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.chequeNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <date-picker :dateString="'申請日期'" :date.sync="editedItem.applyDate" />
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.tradeType === '支票'">
          <v-flex>
            <date-picker :dateString="'支票到期日'" :date.sync="editedItem.chequeExpireTime" />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`預期金額`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.expectedAmount"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-text-field
              :label="`實際金額`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.amount"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md6>
            <v-autocomplete v-if="isAdmin || isAccounting || canEditCompanyDoc"
                            v-model="editedItem.agentId"
                            background-color="#49bcfd"
                            outline
                            :items="getAdminList"
                            label="領受人"
                            item-text="displayName"
                            item-value="agentId"
            ></v-autocomplete>
            <v-text-field v-else
              :label="`領受人`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.applicant"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-autocomplete v-if="isAdmin || isAccounting || canEditCompanyDoc"
              v-model="editedItem.parentAgentId"
              background-color="#49bcfd"
              outline
              :items="getAdminList"
              label="經辦人"
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
            <v-autocomplete v-else
              v-model="editedItem.parentAgentId"
              background-color="#49bcfd"
              outline
              :items="getSelfList"
              label="經辦人"
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md6>
            <v-autocomplete
              v-model="editedItem.manager"
              background-color="#49bcfd"
              outline
              :items="getAdminList"
              label="經理"
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
          </v-flex>
          <v-flex md6>
            <v-autocomplete
              v-model="editedItem.leader"
              background-color="#49bcfd"
              outline
              :items="getAdminList"
              label="董事長"
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="files.length < 6">
              <input ref="files"
                     type="file" :name="uploadFieldName" multiple
                     @change="handleFilesUpload()"
                     accept="image/*,.xlsx,.xls,.csv,.pdf,.doc,.docx,.ppt,.pptx" hidden>
              <v-btn color="success" dark text @click="chooseFile">新增檔案</v-btn>

<!--              <span v-if="files && files.length > 0"> {{ files.length > 0 ? files[0].name : '' }}</span>-->
<!--              <span v-else-if="editedItem.fileName !== ''"> {{ editedItem.fileName }}</span>-->
            </div>
          </v-flex>
          <v-flex xs12 v-if="message !==''">
            <span style="color: red;">{{ message }}</span>
          </v-flex>
          <v-flex xs12 v-if="files.length">
            <v-layout row v-for="(file, i) of files" :key="`file_${i}`">
              <v-flex>
                <div>{{ file.name }}</div>
              </v-flex>
              <v-flex>
                <v-btn color="red" dark text @click="deleteFile(i)">刪除</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.imageURL1 !==''">
          <v-flex md12>
            <img :src="editedItem.imageURL1" style="max-width: 500px;">
          </v-flex>
          <v-flex>
            <v-btn color="red" dark text @click="deleteFile(0)">刪除</v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.imageURL2 !==''">
          <v-flex md12>
            <img :src="editedItem.imageURL2" style="max-width: 500px;">
          </v-flex>
          <v-flex>
            <v-btn color="red" dark text @click="deleteFile(1)">刪除</v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.imageURL3 !==''">
          <v-flex md12>
            <img :src="editedItem.imageURL3" style="max-width: 500px;">
          </v-flex>
          <v-flex>
            <v-btn color="red" dark text @click="deleteFile(2)">刪除</v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.imageURL4 !==''">
          <v-flex md12>
            <img :src="editedItem.imageURL4" style="max-width: 500px;">
          </v-flex>
          <v-flex>
            <v-btn color="red" dark text @click="deleteFile(3)">刪除</v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.imageURL5 !==''">
          <v-flex md12>
            <img :src="editedItem.imageURL5" style="max-width: 500px;">
          </v-flex>
          <v-flex>
            <v-btn color="red" dark text @click="deleteFile(4)">刪除</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" dark text v-if="!isNew" @click="deleteEvent">刪除</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelEvent">取消</v-btn>
        <v-btn color="primary" :loading="loading" dark text @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from 'vuex';
import DatePicker from "@/components/DatePicker";
import common from '@/mixins/common';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'CompanyDocDialog',
  components:{ DatePicker },
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
    loading: Boolean,
  },
  mixins:[common],
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      menu: false,
      fileList:[],
      uploadFieldName: 'files',
      files: [],
      categoryList: ['零用金', '獎金申請','收入款項', '費用支出'],
      departmentList: ['六A','九總-賀丞交', '九總-嘉好', '九總-上勇', '九總-國祥', '九總-聖錩', '九總-鈔錢佈數', '九總-嘉昌賀','電銷部'],
      invoiceTypeList: ['收據','估價單', '二聯式發票', '三聯式發票'],
      tradeTypeList: ['現金','銀行存款','匯款','刷卡','支票'],
      inAccountTypeList: [ "客戶應收-嘉好",
        "客戶應收-上勇",
        "客戶應收-國祥",
        "客戶應收-聖錩",
        "客戶應收-鈔錢佈數",
        "客戶應收-賀丞交",
        "客戶應收-嘉昌賀",
        "其他費用-房租"],
      outAccountTypeList: [
        "管理費",
        "廠商應付-嘉好",
        "廠商應付-上勇",
        "廠商應付-國祥",
        "廠商應付-聖錩",
        "廠商應付-鈔錢佈數",
        "廠商應付-賀丞交",
        "廠商應付-嘉昌賀",
        "人事費-員工薪資",
        "人事費-臨時工資",
        "人事費-其他加給",
        "人事費-加班值班費",
        "人事費-獎金",
        "人事費-員工保險費",
        "人事費-員工退休退職金",
        "人事費-伙食津貼",
        "人事費-職工福利",
        "人事費-其他人事費用",
        "事務費-文具用品",
        "事務費-印刷及裝訂費",
        "事務費-書報雜誌",
        "事務費-電腦使用費",
        "事務費-水電費",
        "事務費-郵電費",
        "事務費-租金支出",
        "事務費-專業服務費",
        "事務費-廣告費",
        "事務費-訓練費",
        "事務費-其他事務費",
        "旅運費-交通費",
        "旅運費-住宿費",
        "旅運費-膳雜費",
        "旅運費-油費",
        "旅運費-搬運費",
        "旅運費-車馬補助費",
        "旅運費-其他旅運費",
        "財產使用費-雜項購置",
        "財產使用費-維修費",
        "財產使用費-管理清潔費",
        "財產使用費-財產保險費",
        "財產使用費-折舊費用",
        "財產使用費-各項攤銷",
        "財產使用費-稅捐及規費",
        "財產使用費-其他財產使用費",
        "活動費-會議費",
        "活動費-稿費",
        "活動費-聯誼活動費",
        "活動費-業務推廣費",
        "活動費-展覽費",
        "活動費-考察觀摩費",
        "活動費-刊物編輯費",
        "活動費-調查統計費",
        "活動費-研究發展費",
        "活動費-獎學金",
        "活動費-捐贈支出",
        "活動費-補助支出",
        "活動費-其他活動費",
        "其他費用-呆帳",
        "其他費用-雜項支出",
        "其他費用-嘉好購票",
        "其他費用-上勇購票",
        "其他費用-國祥購票",
        "其他費用-聖錩購票",
        "其他費用-鈔錢佈數購票",
        "其他費用-賀丞交購票",
        "其他費用-嘉昌賀購票",
        "其他費用-房貸",
        "其他費用-火險",
      ],
      message: '',
      agentItems: [],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(["getUserInfo",'getAgentList']),
    editedItem() {
      return this.item;
    },
    getSelfList(){
      return this.getAgentList.filter(agent=>agent.agentId === this.getUserInfo.agentId);
    },
    agentList(){
      return this.getAgentList.filter(agent=>agent.enable === true);
    },
    getStaffList(){
      return this.getAgentList.filter(agent=>agent.enable === true && agent.authority === 'staff');
    },
    getManagerList(){
      return this.getAgentList.filter(agent=>agent.enable === true && agent.authority === 'manager');
    },
    getAdminList(){
      return this.getAgentList.filter(agent=>agent.enable === true && agent.authority === 'admin' || agent.authority === 'staff' ||  agent.authority === 'manager'
      || agent.agentId === 'pBKB1EUsfDgmvHzdw5SHAWBXIBg2');
    }
  },
  watch: {
    visible(value) {
      console.log(`doc visible = ${value}`);
      if (this.isNew){
        this.item.applicant = this.getUserInfo.displayName;
        this.item.agentId = this.getUserInfo.agentId;
      }
      if (value){
        this.files = [];
        this.fetchAgentList();
      }
    },
    loading(value) {
      console.log(`doc loading = ${value}`);
    },
    'editedItem.agentId':{
      handler: function (value) {
        const find = this.agentList.find(agent=>agent.agentId === value);
        if (find){
          this.item.applicant = find.displayName;
          this.item.agentId = find.agentId;
        }
        console.log(`變更領受人 = ${JSON.stringify(this.item)}`);
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions(['fetchAgentList',]),
    chooseFile(){
      this.$refs.files.click();
    },
    deleteFile(i){
      if (this.files.length > 0){
        this.files.splice(i, 1);
      }
      this.editedItem[`imageURL${i+1}`] = '';
      this.$emit("deleteFileEvent", { index: i+1 });
    },
    handleFilesUpload() {
      console.log('handleFilesUpload');
      for (let file of Array.from(this.$refs.files.files)){
        this.files.push(file);
      }
      this.$refs.files.value = null;
      console.log(this.files);
      if (this.files.length > 5){
        this.message = '檔案最多5個!'
        return;
      }
      // this.files = this.$refs.files.files;
    },
    confirmEvent() {
      this.message = '';

      if (!this.editedItem.amount || this.editedItem.amount ===''){
        this.showMessageDialog('請輸入金額！')
        return;
      }

      if (!this.editedItem.applyDate || this.editedItem.applyDate === ''){
        this.showMessageDialog('請輸入申請日期！')
        return;
      }

      this.$emit("confirmEvent", { item: this.editedItem, files: this.files });
    },
    cancelEvent() {
      this.files = [];
      this.message = '';
      this.$emit("cancelEvent");
    },
    deleteEvent(){
      this.$emit("deleteEvent", this.editedItem.docId);
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CompanyDocDialog.vue